//export const API_URL = "http://146.56.183.55:5050";
export const API_URL = "https://api.mandarin.cf";
export const NEWS_URL = "/nature/NAT/FOD/list";
export const API_KEY = "bab964d3aa411e290f2f38cdf3ccc430";
